/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppBatchGetPersonsMutationRequest, WebAppBatchGetPersonsMutationResponse } from "../models/WebAppBatchGetPersons";

export function getWebAppBatchGetPersonsUrl() {
  const res = { method: 'POST', url: `/web-app/v1/persons/batch-get` as const }
  return res
}

/**
 * @description Retrieves up to 1,000 persons by id. Duplicate ids are ignored while preserving order. Missing ids are returned in `missingPersonIds`.
 * @summary Batch get persons
 * {@link /web-app/v1/persons/batch-get}
 */
export async function webAppBatchGetPersons(data: WebAppBatchGetPersonsMutationRequest, config: Partial<RequestConfig<WebAppBatchGetPersonsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppBatchGetPersonsMutationResponse, ResponseErrorConfig<Error>, WebAppBatchGetPersonsMutationRequest>({ method : "POST", url : getWebAppBatchGetPersonsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}